import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell } from "@/components/DashboardShell";
import { CUSTOMER_NAV } from "@/lib/nav";
import { NotificationCenter } from "@/components/NotificationCenter";

export const Route = createFileRoute("/_authenticated/customer/notifications")({
  head: () => ({
    meta: [
      { title: "Notifications · Landoo" },
      {
        name: "description",
        content: "Enquiry replies, contact approvals and account updates for your Landoo activity.",
      },
      { property: "og:title", content: "Notifications · Landoo" },
      {
        property: "og:description",
        content: "Enquiry replies, contact approvals and account updates for your Landoo activity.",
      },
    ],
  }),
  component: () => (
    <DashboardShell title="Notifications" role="Customer" items={CUSTOMER_NAV}>
      <NotificationCenter />
    </DashboardShell>
  ),
});
